import { component } from 'picoapp'
import app from '@/app.js'

export default component((node, ctx) => {
  //console.log('curtain mounted')
  const closeCurtain = node.querySelector('.js-curtain')
  const body = document.querySelector('body')

  const close = () => {
    node.classList.remove('is-visible')
    body.classList.remove('curtain-open')
    setTimeout(() => {
      ctx.emit('curtain:closed', state => {
        return {
          curtainOpen: false
        }
      })
    }, 250)
    
    setTimeout(() => {
      node.classList.remove('is-active')
      //app.hydrate({curtainOpen: false})
    }, 750)
  }

  closeCurtain.addEventListener('click', close)

  return node => {
    //console.log('curtain unmounted')
  }
})
